module.exports = __webpack_public_path__ + "static/media/mayur-black.19872676.jpg";